import { ButtonPage } from "./styles";
import { useState } from "react";
import { useEffect } from "react";

export const Button = ({ onClick, disabled, children }) => {
  const [buttonColor, setButtonColor] = useState("");

  useEffect(() => {
    !disabled && setButtonColor("#fff");
  }, [disabled]);

  return (
    <ButtonPage onClick={onClick} disabled={disabled} buttonColor={buttonColor}>
      {children}
    </ButtonPage>
  );
};
